import React from "react";
import { ClickableImage } from "../common";
import "../../styles/Notable.css";

function Notable() {
  return (
    <div className="Notable">
      <div className="timeline">

        <div className="timeline-item">
          <div className="timeline-dot" />
          <div className="timeline-card">
            <span className="timeline-date">May 2026</span>
            <h1>2nd Place — Capstone Project Competition</h1>
            <p>I won 2nd place at my university's capstone project presentation competition.</p>
            <div className="timeline-photos">
              <ClickableImage src="presentation1.jpg" alt="Capstone Presentation" />
              <ClickableImage src="price.jpg" alt="Prize" />
              <ClickableImage src="presentation2.jpg" alt="Capstone Presentation" />
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot" />
          <div className="timeline-card">
            <span className="timeline-date">April 2026</span>
            <h1>1st Place & People's Choice — Bank of Canada AI Hackathon</h1>
            <p>
              I competed in pairs at a creative AI hackathon organized by the Bank of Canada.
              Out of 60 participants, our team of two won both available prizes: first place and
              the public's choice award.
            </p>
            <div className="timeline-photos">
              <ClickableImage src="Bank.jpg" alt="Bank of Canada" />
              <ClickableImage src="AI.jpg" alt="AI Hackathon" />
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot" />
          <div className="timeline-card">
            <span className="timeline-date">November 2025</span>
            <h1>2nd Place — uCTF 2025</h1>
            <p>
              I led team G0ne Ph1sh1ng at UQO's CTF competition over 24 hours, competing against
              13 teams. As team captain, we placed 2nd overall. I personally ranked 3rd in
              individual points out of 40 participants. Challenges included SQL injection, Neo4J
              injection, reverse engineering, steganography, cryptography, social engineering,
              and lock picking.
            </p>
            <div className="timeline-photos">
              <ClickableImage src="uctf1.png" alt="uCTF 2025" />
              <ClickableImage src="uctf3.jpg" alt="G0ne Ph1sh1ng Team" />
              <ClickableImage src="uctf2.png" alt="uCTF Competition" />
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot" />
          <div className="timeline-card">
            <span className="timeline-date">2024</span>
            <h1>CS Games — Montreal 2024</h1>
            <p>
              I represented UQO in the Theoretical Computer Sciences event at the CS Games,
              bringing together ~15 universities from Canada and the USA. Each challenge was
              completed in pairs; I was the senior member of my team.
            </p>
            <div className="timeline-photos timeline-photos--single">
              <ClickableImage src="csgames1.jpg" alt="CS Games 2024" />
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-dot" />
          <div className="timeline-card">
            <span className="timeline-date">March 2023</span>
            <h1>1st Place — uHack 2023 Hackathon</h1>
            <p>
              I led the winning team at UQO's Hackathon over 2 days, in a team of 5. We built
              an interactive website to help the CREDDO communicate with local cities about wind
              and solar energy possibilities, using geomatic data. Our project won first prize,
              including a 2-night stay at Dômes Outaouais. I also participated in the 2024 and
              2025 editions.
            </p>
            <div className="timeline-photos">
              <ClickableImage src="victory.jpg" alt="uHack23" />
              <ClickableImage src="creddowebsite.jpg" alt="creddo" />
            </div>
            <a href="https://uqo.ca/nouvelles/50536" target="_blank" rel="noreferrer">
              uqo.ca/nouvelles/50536
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Notable;
